import React, { useEffect, useState } from 'react'
import MsgUtils from '../Tools/MsgUtils';
import ItemSucursaltr from './ItemSucursaltr';
const server = process.env.REACT_APP_SERVER;

function InventarioTReal() {
    const [regional,setRegional] = useState(JSON.parse(localStorage.getItem('info')).ID_REGIONAL_ACTUAL)
    const [sucursales, setSucursales] = useState([]);
    const [actualizar,setActualizar] = useState(false);
    const [columnas,setColumnas] = useState(0);
    function sumarColumnas(){
        setColumnas(columnas=>columnas+1);
    }
    
    function sumarValores(columna) {
        var table = document.getElementById('inveTabla')
        try{
            var tr = table.getElementsByTagName("tr");
            var suma = 0
            var i;
            for (i = 0; i < tr.length; i++) {
                var td = tr[i].getElementsByTagName("td")[columna];
                if (td) {
                    var txtValue = td.textContent || td.innerText;
                    //console.log(!isNaN(txtValue))
                    if (txtValue.includes('+')) {
                        // Si tenemos el simbolo mas (+) debemos separar ambos miembros
                        var datos = txtValue.split('+')
                        suma = suma + (parseInt(datos[0])*100) + parseInt(datos[1]);
                    } else {
                        // Solo sumamos si es un numero valido
                        var valor = parseFloat(txtValue);
                        if (!isNaN(valor)) {
                            suma = suma + valor;
                        }
                    }

                    /*if (txtValue != '?' && txtValue != 'ERR'&&!isNaN(txtValue)&&txtValue!='') {
                        if(columna==2){
                            var datos = txtValue.split('+')
                            suma = suma + (parseInt(datos[0])*100)+parseInt(datos[1])
                        }else{
                            suma = suma + parseFloat(txtValue)
                        }
                    }*/
                }
            }

            // Formato del total
            if(columna == 2){
                var resultado = `${parseInt(suma/100)} + ${parseInt(suma%100)}`
                return resultado
            }else{
                return suma
            }
        }catch{
            return 0
        }
    }
    useEffect(() => {
        fetch(`${server}/sqlComun/getSucursales`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                regional
            })
        })
            .then(res => res.json())
            .then(data => {
                if (data.error) {
                    MsgUtils.msgError(data.error);
                } else {
                    //getInformacionProyeccion();
                    console.log(data.ok)
                    setSucursales(data.ok);
                }
                
            })
            .catch(error => MsgUtils.msgError(error));
    }, [])
    return (
        <>
            <div className='bg-dark container-fluid'>
                <div className='btn-group py-1'>
                    <button className='btn btn-success btn-sm' onClick={()=>setActualizar(!actualizar)}><i className="fa-solid fa-repeat"></i> Recargar</button>
                </div>
            </div>
            <div className='table-responsive'>
                <table className="table table-sm table-dark table-bordered border-4" id='inveTabla'>
                    <thead>
                        <tr className='text-center'>
                            <th>SUCURSALES</th>
                            <th>PECH+ALA</th>
                            <th>PIER+ENTRE</th>
                            <th>BANDEJAS Pollo</th>
                            <th>PIPOCA</th>
                            <th>ARROZ</th>
                            <th>FRIJOL</th>
                            <th>FRUTI</th>
                            <th>MARAC</th>
                            <th>MANGO</th>
                            <th>PAPA</th>
                        </tr>
                    </thead>
                    <tbody>
                        {sucursales.map((item,index)=>{
                            return(
                                <ItemSucursaltr sucursal={item} actualizar={actualizar} collback={()=>sumarColumnas()} key={index}/>
                            )
                        })}
                    </tbody>
                    {(columnas > 0) &&<tfoot className='fondoMostasa text-center'>
                        <tr>
                            <th></th>
                            <th>{parseInt(sumarValores(0))}</th>
                            <th>{parseInt(sumarValores(1))}</th>
                            <th>{sumarValores(2)}</th>
                            <th>{parseInt(sumarValores(3))}</th>
                            <th>{parseInt(sumarValores(4))}</th>
                            <th>{parseInt(sumarValores(5))}</th>
                            <th>{sumarValores(6).toFixed(2)}</th>
                            <th>{sumarValores(7).toFixed(2)}</th>
                            <th>{sumarValores(8).toFixed(2)}</th>
                            <th>{sumarValores(9).toFixed(2)}</th>
                        </tr>
                    </tfoot>}
                </table>
            </div>
        </>
    )
}

export default InventarioTReal